import { type CartPageContentProps } from '@src/components/CartPageContent/CartPageContent.props'

export const CartPageContentDefaults = {
  copy: {
    orderSummary: 'Order summary',
    subtotal: 'Subtotal',
    yourCart: 'Your cart',
    subtotalDisclaimer: '*Shipping & taxes calculated at checkout',
    continue: 'Continue to Checkout',
    emptyCart: 'Your cart is currently empty',
    continueShopping: 'Continue Shopping',
  },
  emptyCartCtaLink: '/c/fitness',
  isDrawer: false,
} satisfies CartPageContentProps
